var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symptomInfo"},_vm._l((_vm.dsListFilter),function(item,index){return _c('div',{key:index,staticClass:"bt",class:'b' + item.type},[_c('span',[_vm._v(_vm._s(item.label)+"：")]),_c('span',[_vm._v(_vm._s(item.dsNames))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }